import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

const API = '/api/v1/kasir/engagement/my-designs';

function createKasirMyDesign() {
  return {
    tab: 'queue',
    status: 'pending',
    sort: 'likes',
    q: '',
    loading: false,
    saving: false,
    items: [],
    reports: [],
    stats: {},
    detail: null,
    settings: {
      enabled: false,
      upload_enabled: true,
      social_enabled: true,
      rewards_enabled: true,
      ads_enabled: true,
      require_admin_for_publish: true,
      ads: { feed_frequency: 7, enable_rewarded_ads: false },
    },

    init() {
      try {
        const raw = this.$el.getAttribute('data-analytics');
        this.stats = raw ? JSON.parse(raw) : {};
      } catch {
        this.stats = {};
      }
      this.fetchList();
    },

    fmtNum(n) {
      return Number(n || 0).toLocaleString('id-ID');
    },

    fmtRating(n) {
      const v = Number(n || 0);
      return Number.isFinite(v) ? v.toFixed(1) : '0.0';
    },

    async fetchList() {
      this.loading = true;
      try {
        const { data } = await axios.get(API, {
          params: {
            status: this.status,
            sort: this.sort || 'likes',
            q: this.q || undefined,
            per_page: 30,
          },
        });
        this.items = data.data || [];
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat daftar.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async fetchReports() {
      try {
        const { data } = await axios.get(`${API}/reports`, { params: { status: 'open' } });
        this.reports = data.data || [];
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat laporan.', 'error');
      }
    },

    async openDetail(d) {
      try {
        const { data } = await axios.get(`${API}/${d.id}`);
        this.detail = data.data;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat detail.', 'error');
      }
    },

    async approve(d) {
      try {
        const { data } = await axios.post(`${API}/${d.id}/approve`);
        window.toast?.(data.message || 'Disetujui.', 'success');
        this.fetchList();
        this.refreshAnalytics();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal approve.', 'error');
      }
    },

    async reject(d) {
      const reason = window.prompt('Alasan penolakan:');
      if (!reason) return;
      try {
        const { data } = await axios.post(`${API}/${d.id}/reject`, { reason });
        window.toast?.(data.message || 'Ditolak.', 'success');
        this.fetchList();
        this.refreshAnalytics();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal reject.', 'error');
      }
    },

    async hide(d) {
      try {
        const { data } = await axios.post(`${API}/${d.id}/hide`);
        window.toast?.(data.message || 'Disembunyikan.', 'success');
        this.fetchList();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal hide.', 'error');
      }
    },

    async resolveReport(r, status) {
      try {
        const { data } = await axios.post(`${API}/reports/${r.id}/resolve`, { status });
        window.toast?.(data.message || 'Laporan ditutup.', 'success');
        this.fetchReports();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal resolve.', 'error');
      }
    },

    async loadSettings() {
      try {
        const { data } = await axios.get(`${API}/settings`);
        this.settings = { ...this.settings, ...(data.data || {}) };
        if (!this.settings.ads) {
          this.settings.ads = { feed_frequency: 7, enable_rewarded_ads: false };
        }
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat settings.', 'error');
      }
    },

    async saveSettings() {
      this.saving = true;
      try {
        const { data } = await axios.put(`${API}/settings`, this.settings);
        this.settings = { ...this.settings, ...(data.data || {}) };
        window.toast?.(data.message || 'Settings disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal simpan.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async refreshAnalytics() {
      try {
        const { data } = await axios.get(`${API}/analytics`);
        this.stats = data.data || this.stats;
      } catch {
        // ignore
      }
    },
  };
}

Alpine.data('kasirMyDesign', createKasirMyDesign);
